import "./DaUnableToLogin.css";
import DaPageWrapper from "../DaPageWrapper/DaPageWrapper";
import { Translate } from "../../helpers/TranslatedComponent";
import { T_KEYS } from "../../locales/translationKeys";

const DaUnableToLogin = () => {
  return (
    <DaPageWrapper
      wrapperClass={"da-unabletologin-card da-page-wrapper"}
      iconType="access_denied"
      title={<Translate tKey={T_KEYS.DA.UNABLE_TO_LOGIN.TITLE} />}
    />
  );
};

export { DaUnableToLogin };
